/* ============================
   Keymax — Video Engine (V1.3.6) STABLE
   - Modal GLOBAL appended to <body> (avoids iOS “tilt” / stacking context bugs)
   - Works with multiple carousels on the same page
   - Quick Buy via Shopify /products/{handle}.js (works on ANY page)
   - Quick Buy constraints per variant (min/step/max) + price/img live update
   - Fix: featured_image can be object/null (no startsWith crash)
============================ */

(() => {
  const SEL = {
    root: "[data-km-video-root]",
    card: "[data-km-video-card]",
    inlineVideo: "[data-km-video-card] video",

    modal: "[data-km-modal]",
    modalBackdrop: "[data-km-modal-backdrop]",
    modalLayout: "[data-km-layout]",
    modalVideo: "video[data-km-modal-video]",

    btnClose: "[data-km-close]",
    btnMute: "[data-km-mute]",
    btnPause: "[data-km-pause]",
    btnBuy: "[data-km-buy]",
    btnPrev: "[data-km-prev]",
    btnNext: "[data-km-next]",

    side: "[data-km-side]",
    btnSideClose: "[data-km-side-close]",

    hudImg: "[data-km-hud-img]",
    hudTitle: "[data-km-hud-title]",
    hudPrice: "[data-km-hud-price]",

    prog: "[data-km-prog]",
    progFill: "[data-km-prog-fill]",
    progText: "[data-km-prog-text]",
  };

  let ACTIVE_ROOT = null;

  const prefersReducedMotion = () =>
    window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  const clamp = (n, a, b) => Math.max(a, Math.min(b, n));

  function applyRootBlurFromSection(root){
  try{
    const section = root && root.closest(".km-video-carousel");
    if (!section) return;

    const val = getComputedStyle(section).getPropertyValue("--km-blur");
    const blur = (val || "").trim();
    if (blur) document.documentElement.style.setProperty("--km-blur", blur);
  }catch(e){}
}

  function hardHideAllModals() {
    document.querySelectorAll(SEL.modal).forEach((m) => {
      m.setAttribute("aria-hidden", "true");
      m.hidden = true;
      m.style.display = "none";
    });
  }

  function safePlay(video) {
    if (!video) return;
    const p = video.play();
    if (p && typeof p.catch === "function") {
      p.catch(() => {
        video.muted = true;
        const p2 = video.play();
        if (p2 && typeof p2.catch === "function") p2.catch(() => {});
      });
    }
  }

  function safePause(video) {
    if (!video) return;
    try {
      video.pause();
    } catch (e) {}
  }

  function setupAutoplay(root) {
    if (!root) return;
    const videos = Array.from(root.querySelectorAll(SEL.inlineVideo));
    if (!videos.length) return;

    videos.forEach((v) => {
      v.muted = true;
      v.playsInline = true;
      v.style.pointerEvents = "none";
      v.loop = true;
      v.preload = "metadata";
      v.setAttribute("muted", "");
      v.setAttribute("playsinline", "");
      v.setAttribute("webkit-playsinline", "");
      v.autoplay = true;
      v.controls = false;
      v.removeAttribute("controls");
    });

    if (prefersReducedMotion()) return;

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const v = entry.target;
          if (entry.isIntersecting) safePlay(v);
          else safePause(v);
        });
      },
      { threshold: 0.25 }
    );

    videos.forEach((v) => io.observe(v));
  }

  /* ============================
     MODAL GLOBAL
  ============================ */
  function ensureModal() {
    let modal = document.querySelector(SEL.modal);
    if (modal) return modal;

    modal = document.createElement("div");
    modal.setAttribute("data-km-modal", "");
    modal.setAttribute("aria-hidden", "true");
    modal.className = "km-video-modal";
    modal.hidden = true;
    modal.style.display = "none";

    modal.innerHTML = `
      <div class="km-video-modal__backdrop" data-km-modal-backdrop></div>
      <div class="km-video-modal__panel" role="dialog" aria-modal="true">
        <button class="km-video-modal__close" type="button" data-km-close aria-label="Fechar">
  <span class="km-icon km-icon--close" aria-hidden="true">
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 2L2 12" stroke="currentColor" stroke-width="var(--icon-stroke-width)" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M12 12L2 2" stroke="currentColor" stroke-width="var(--icon-stroke-width)" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </span>
</button>

        <div class="km-video-modal__layout" data-km-layout>
          <div class="km-video-modal__stage">
            <video class="km-video-modal__video" data-km-modal-video playsinline preload="metadata" disablepictureinpicture></video>

            <button class="km-video-modal__nav km-video-modal__nav--prev" type="button" data-km-prev aria-label="Anterior">
  <span class="km-icon km-icon--arrow" aria-hidden="true">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none">
      <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="var(--icon-stroke-width)" vector-effect="non-scaling-stroke" d="M4.25 10h11.5m0 0-4-4m4 4-4 4"/>
    </svg>
  </span>
</button>

<button class="km-video-modal__nav km-video-modal__nav--next" type="button" data-km-next aria-label="Próximo">
  <span class="km-icon km-icon--arrow" aria-hidden="true">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none">
      <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="var(--icon-stroke-width)" vector-effect="non-scaling-stroke" d="M4.25 10h11.5m0 0-4-4m4 4-4 4"/>
    </svg>
  </span>
</button>

            <div class="km-video-modal__hud">
              <div class="km-video-modal__prodline">
                <img class="km-video-modal__prod-img" data-km-hud-img alt="" />
                <div class="km-video-modal__prod-txt">
                  <div class="km-video-modal__prod-title" data-km-hud-title></div>
                  <div class="km-video-modal__prod-price" data-km-hud-price></div>
                </div>
              </div>

              <div class="km-video-modal__controls">
                <button class="km-video-modal__btn" type="button" data-km-pause aria-pressed="false" title="Play/Pause">
  <span class="km-icon km-icon--playpause" aria-hidden="true"></span>
</button>
                <button class="km-video-modal__btn" type="button" data-km-mute aria-pressed="true" title="Som">
  <span class="km-icon km-icon--sound" aria-hidden="true"></span>
</button>

              </div>

              <div class="km-video-modal__progress" data-km-prog title="Arraste para avançar">
                <div class="km-video-modal__progress-fill" data-km-prog-fill></div>
              </div>

              <div class="km-video-modal__bottom">
                <div class="km-video-modal__time" data-km-prog-text></div>
                <button class="km-video-modal__cta" type="button" data-km-buy aria-hidden="true">Comprar Agora</button>
              </div>
            </div>
          </div>

          <aside class="km-video-modal__side" data-km-side hidden></aside>
        </div>
      </div>
    `;

    document.body.appendChild(modal);

    if (!document.getElementById("km-video-modal-css")) {
      const style = document.createElement("style");
      style.id = "km-video-modal-css";
      style.textContent = `
  :root{
    --km-glass-bg: rgba(255,255,255,.14);
    --km-glass-bg-strong: rgba(255,255,255,.10);
    --km-glass-border: rgba(255,255,255,.15);
    --km-glass-shadow: 0 18px 60px rgba(0,0,0,.22);
    --km-glass-blur: var(--km-blur, 5px);
  }

  .km-video-modal{ position:fixed; inset:0; display:none; z-index:2147483000; }
  .km-video-modal[aria-hidden="false"]{ display:block; }

  .km-video-modal__backdrop{
    position:absolute; inset:0;
    background: rgba(0,0,0,.55);
    backdrop-filter: blur(var(--km-glass-blur));
    -webkit-backdrop-filter: blur(var(--km-glass-blur));
  }

  /* Icon base (usa padrão do tema) */
.km-video-modal .km-icon{
  display:inline-flex;
  width:18px;
  height:18px;
}
.km-video-modal .km-icon svg{
  width:100%;
  height:100%;
  display:block;
}

/* Prev = espelha a seta */
.km-video-modal__nav--prev .km-icon--arrow{
  transform: scaleX(-1);
}

  .km-video-modal__panel{
    position:absolute; inset:0;
    display:flex; align-items:center; justify-content:center;
    padding:22px;
  }

  /* ✅ Close (glass branco + borda) */
  .km-video-modal__close{
    position:absolute; top:18px; right:18px;
    width:44px; height:44px;
    border-radius:999px;
    border:1px solid var(--km-glass-border);
    background: var(--km-glass-bg);
    backdrop-filter: blur(var(--km-glass-blur));
    -webkit-backdrop-filter: blur(var(--km-glass-blur));
    color:#fff;
    font-size:26px;
    cursor:pointer;
    z-index:60;
  }

  .km-video-modal__layout{
    width:min(1180px, 96vw);
    display:flex;
    align-items:stretch;
    justify-content:center;
    position:relative;
  }

  .km-video-modal__stage{
    position:relative;
    border-radius:18px;
    overflow:hidden;
    box-shadow: var(--km-glass-shadow);
    height: min(86vh, 820px);
    aspect-ratio: 9 / 16;
    background: transparent;
    display:flex;
    align-items:center;
    justify-content:center;
  }

  .km-video-modal__video{
    width:100%;
    height:100%;
    display:block;
    object-fit: contain;
    background: transparent;
    outline:none;
  }

  .km-video-modal__video::-webkit-media-controls,
  .km-video-modal__video::-webkit-media-controls-enclosure{ display:none !important; }

  /* ✅ Nav arrows (glass branco + borda) */
  .km-video-modal__nav{
    position:absolute;
    top:50%;
    transform: translateY(-50%);
    z-index:25;
    width:44px;
    height:44px;
    border-radius:999px;
    border:1px solid var(--km-glass-border);
    background: var(--km-glass-bg);
    backdrop-filter: blur(var(--km-glass-blur));
    -webkit-backdrop-filter: blur(var(--km-glass-blur));
    color:#fff;
    cursor:pointer;
    display:flex;
    align-items:center;
    justify-content:center;
    font-size:22px;
    line-height:1;
  }
  .km-video-modal__nav--prev{ left:14px; }
  .km-video-modal__nav--next{ right:14px; }

  /* HUD container */
  .km-video-modal__hud{
    position:absolute;
    left:14px; right:14px; bottom:14px;
    z-index:30;
    pointer-events:none;
  }
  .km-video-modal__hud > *{ pointer-events:auto; }

  /* ✅ Product HUD (glass branco + borda, sem “card escuro”) */
  .km-video-modal__prodline{
    display:flex;
    align-items:center;
    gap:10px;
    padding:10px 12px;
    border-radius:16px;
    border:1px solid var(--km-glass-border);
    background: var(--km-glass-bg-strong);
    backdrop-filter: blur(var(--km-glass-blur));
    -webkit-backdrop-filter: blur(var(--km-glass-blur));
    color:#fff;
    margin-bottom:10px;
  }

  .km-video-modal__prod-img{
    width:42px; height:42px;
    border-radius:12px;
    object-fit:cover;
    background: rgba(255,255,255,.10);
    flex:0 0 auto;
  }

  .km-video-modal__prod-title{
  font-size:14px;
  font-weight:600;
  white-space:nowrap;
  overflow:hidden;
  text-overflow:ellipsis;
  max-width: 100%;
}

.km-video-modal__prod-txt{
  min-width:0; /* importante pra ellipsis funcionar em flex */
  flex:1 1 auto;
}

  .km-video-modal__prod-price{
    font-size:13px;
    opacity:.92;
    white-space:nowrap;
    overflow:hidden;
    text-overflow:ellipsis;
  }

  /* ✅ Controls stack (mute/pause) */
  .km-video-modal__controls{
    position:absolute;
    right:0px;
    bottom:170px;
    display:flex;
    flex-direction:column;
    gap:5px;
    z-index:35;
    pointer-events:auto;
  }

  .km-video-modal__btn{
    width:44px;
    height:44px;
    border-radius:999px;
    border:1px solid var(--km-glass-border);
    background: var(--km-glass-bg);
    backdrop-filter: blur(var(--km-glass-blur));
    -webkit-backdrop-filter: blur(var(--km-glass-blur));
    color:#fff;
    cursor:pointer;
    display:grid;
    place-items:center;
    font-size:14px;
    line-height:1;
  }

  /* ✅ Progress bar mantém claro (pode ficar glass também) */
  .km-video-modal__progress{
    height:6px;
    border-radius:999px;
    background: rgba(255,255,255,.16);
    backdrop-filter: blur(var(--km-glass-blur));
    -webkit-backdrop-filter: blur(var(--km-glass-blur));
    overflow:hidden;
    cursor:pointer;
    margin-bottom:10px;
  }

  .km-video-modal__progress-fill{
    height:100%;
    width:0%;
    background: rgba(255,255,255,.92);
  }

  .km-video-modal__bottom{
    display:flex;
    align-items:center;
    justify-content:space-between;
    gap:12px;
  }

  .km-video-modal__time{
    color:#fff;
    font-size:12px;
    opacity:.9;
    min-width:90px;
  }

  /* ✅ CTA: pill 999px, blur branco, fonte do tema, uppercase, central */
  .km-video-modal__cta{
    width:100%;
    border:1px solid var(--km-glass-border);
    border-radius:999px;
    padding:14px 22px;
    background: var(--km-glass-bg-strong);
    backdrop-filter: blur(var(--km-glass-blur));
    -webkit-backdrop-filter: blur(var(--km-glass-blur));
    color:#fff;
    font: inherit;                 /* pega fonte padrão do tema */
    font-weight:400;
    text-transform: uppercase;
    letter-spacing: .04em;
    display:flex;
    align-items:center;
    justify-content:center;
    text-align:center;
    cursor:pointer;
  }

  .km-video-modal__side{
    width:min(420px, 38vw);
    height:min(86vh, 820px);
    background: rgba(255,255,255,.94);
    color:#111;
    border-radius:16px;
    overflow:auto;
    padding:14px;
    margin-left:14px;
    display:none;
    position:relative;
  }
  .km-video-modal__layout.has-side .km-video-modal__side{ display:block; }

  .km-video-modal__side-close{
    position:absolute;
    top:10px;
    right:12px;
    width:38px;
    height:38px;
    border-radius:999px;
    border:0;
    background: rgba(0,0,0,.08);
    color:#111;
    font-size:22px;
    line-height:1;
    cursor:pointer;
    display:none;
  }

  @media (max-width: 989px){
    .km-video-modal__panel{
      padding:0;
      align-items:stretch;
      justify-content:stretch;
      padding-left: env(safe-area-inset-left);
      padding-right: env(safe-area-inset-right);
    }

    .km-video-modal__layout{
      width:100vw;
      height:100dvh;
      max-width:none;
      overflow:hidden;
    }

    .km-video-modal__stage{
      width:100%;
      height:100%;
      aspect-ratio:auto;
      border-radius:0;
    }

    .km-video-modal__video{
      object-fit:cover;
      background:#000;
    }

    .km-video-modal__hud{
      left:12px; right:12px;
      bottom: calc(12px + env(safe-area-inset-bottom));
    }

    .km-video-modal__controls{
      right:12px;
      bottom: calc(160px + env(safe-area-inset-bottom));
    }

    .km-video-modal__side{
      position:absolute;
      left:0; right:0; bottom:0;
      width:100vw; max-width:none;
      margin:0;
      height:50dvh;
      max-height:70dvh;
      overflow:auto;
      -webkit-overflow-scrolling:touch;
      padding:20px 16px 24px; /* mais respiro do topo */
      padding-bottom: calc(24px + env(safe-area-inset-bottom));
      border-radius:20px 20px 0 0;
      background:#fff;
      z-index: 9999;
      transform: translateY(110%);
      transition: transform .28s ease;
    }

    .km-video-modal__layout.has-side .km-video-modal__side{
      display:block;
      transform: translateY(0);
    }

    .km-video-modal__layout.has-side .km-video-modal__controls{
      display:none !important;
    }

    .km-video-modal__layout.has-side .km-video-modal__hud{
      pointer-events:none;
    }

    .km-video-modal__side::before{
      content:"";
      display:block;
      width:46px;
      height:5px;
      border-radius:999px;
      margin:2px auto 10px;
      background: rgba(0,0,0,.18);
    }

    .km-video-modal__side-close{ display:block; }
  }
`;
      document.head.appendChild(style);
    }

    return modal;
  }

  /* ============================
     CARDS / STATE (per ACTIVE_ROOT)
  ============================ */
  function getCards(root) {
    return Array.from((root || document).querySelectorAll(SEL.card));
  }
  function getCardIndex(root, card) {
    return Math.max(0, getCards(root).indexOf(card));
  }
  function getMp4FromCard(card) {
    return card?.getAttribute("data-km-src") || "";
  }
  function getHandleFromCard(card) {
    return (card?.getAttribute("data-km-product-handle") || "").trim();
  }
  function getMetaFromCard(card) {
    return {
      title: (card?.getAttribute("data-km-product-title") || "").trim(),
      price: (card?.getAttribute("data-km-product-price") || "").trim(),
      image: (card?.getAttribute("data-km-product-image") || "").trim(),
    };
  }

  function setModalState(modal, state) {
    modal.__kmModalState = { ...(modal.__kmModalState || {}), ...state };
  }
  function getModalState(modal) {
    return modal.__kmModalState || { index: 0, handle: "" };
  }

  function setBuyVisible(modal, visible) {
    const btnBuy = modal.querySelector(SEL.btnBuy);
    if (!btnBuy) return;
    btnBuy.style.display = visible ? "inline-flex" : "none";
    btnBuy.setAttribute("aria-hidden", visible ? "false" : "true");
  }

  function openSide(modal, open) {
    const side = modal.querySelector(SEL.side);
    const layout = modal.querySelector(SEL.modalLayout);
    if (!side || !layout) return;

    if (open) {
      side.hidden = false;
      layout.classList.add("has-side");
    } else {
      side.hidden = true;
      layout.classList.remove("has-side");
    }
  }

  function updateButtons(modal, video) {
  const btnMute = modal.querySelector(SEL.btnMute);
  const btnPause = modal.querySelector(SEL.btnPause);

  const isMuted = !!video?.muted;
  const isPlaying = video ? !video.paused : false;

  if (btnMute) {
    btnMute.setAttribute("aria-pressed", String(isMuted));
    const slot = btnMute.querySelector(".km-icon--sound");
    if (slot) {
      slot.innerHTML = isMuted
        ? `<svg width="20" height="20" viewBox="0 0 1397 1274" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M304.621 868.885H518.589C525.323 868.885 531.308 870.911 536.545 874.958L873.958 1147.5C909.869 1176.51 937.55 1190 973.461 1190C1022.09 1190 1058 1158.29 1058 1114.44V79.6035C1058 35.7543 1022.09 0 971.961 0C936.05 0 913.61 14.8417 873.958 46.5479L536.545 316.389C531.308 320.436 525.323 322.46 518.589 322.46H304.621C202.874 322.46 152 369.008 152 466.827V725.195C152 823.017 202.874 868.885 304.621 868.885ZM309.858 770.395C281.429 770.395 268.71 758.928 268.71 733.968V458.054C268.71 432.419 281.429 420.952 309.858 420.952H549.263C568.713 420.952 582.931 417.579 600.136 403.412L918.845 142.341C922.586 138.968 927.074 136.944 931.562 136.944C936.804 136.944 941.292 140.317 941.292 146.389V1042.94C941.292 1049 936.804 1053.06 931.562 1053.06C927.821 1053.06 923.333 1051.03 919.592 1047.66L600.136 787.936C582.931 774.442 568.713 770.395 549.263 770.395H309.858Z" fill="currentColor"/>
            <path d="M1298.88 1258.85C1321.32 1279.05 1357.99 1279.05 1380.44 1258.85C1402.14 1237.99 1402.89 1205.68 1380.44 1185.49L98.5898 33.1446C76.1407 12.9518 38.7251 12.9518 16.276 33.1446C-5.42534 52.6648 -5.42534 86.9924 16.276 106.513L1298.88 1258.85Z" fill="currentColor"/>
          </svg>`
        : `<svg width="20" height="20" viewBox="0 0 1671 1328" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1438.96 1173.58C1466.39 1192.13 1500.49 1185.45 1520.5 1157.26C1615.4 1026.72 1671 847.214 1671 663.998C1671 480.788 1616.14 299.801 1520.5 170.737C1500.49 142.551 1466.39 135.875 1438.96 154.419C1411.53 172.962 1407.08 207.825 1428.58 238.236C1509.39 352.465 1556.09 506.007 1556.09 663.998C1556.09 821.991 1507.9 974.053 1428.58 1089.76C1407.82 1120.18 1411.53 1155.04 1438.96 1173.58Z" fill="currentColor"/>
            <path d="M1158.49 981.222C1183.97 998.371 1220.23 993.149 1241.07 964.079C1300.5 888.788 1336 777.716 1336 663.661C1336 549.61 1300.5 439.284 1241.07 363.248C1220.23 334.176 1183.97 328.212 1158.49 346.103C1126.86 366.976 1122.23 404.248 1146.15 434.811C1190.91 494.447 1216.37 577.191 1216.37 663.661C1216.37 750.134 1190.14 832.136 1146.15 892.516C1123 923.825 1126.86 959.607 1158.49 981.222Z" fill="currentColor"/>
            <path d="M152.711 969.653H368.613C375.384 969.653 381.402 971.907 386.668 976.424L725.942 1280.57C762.051 1312.94 789.886 1328 825.995 1328C874.14 1328 911 1292.62 911 1243.68V88.8344C911 39.9002 874.14 0 824.492 0C788.377 0 765.062 16.5623 725.942 51.9455L386.668 353.079C381.402 357.596 375.384 359.855 368.613 359.855H152.711C50.4022 359.855 0 411.801 0 520.961V809.298C0 918.458 51.1544 969.653 152.711 969.653ZM157.977 859.735C130.143 859.735 117.354 846.938 117.354 819.082V511.174C117.354 482.567 130.143 469.769 157.977 469.769H398.704C418.262 469.769 433.308 466.004 450.61 450.195L771.077 158.848C774.839 155.084 778.6 152.825 783.864 152.825C789.135 152.825 793.647 156.59 793.647 163.365V663.623V1163.88C793.647 1170.66 789.135 1175.18 783.864 1175.18C780.102 1175.18 775.59 1172.91 771.077 1169.15L450.61 879.309C433.308 864.251 418.262 859.735 398.704 859.735H157.977Z" fill="currentColor"/>
          </svg>`;
    }
  }

  if (btnPause) {
    btnPause.setAttribute("aria-pressed", String(isPlaying));
    const slot = btnPause.querySelector(".km-icon--playpause");
    if (slot) {
      slot.innerHTML = isPlaying
        ? `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.5 5v10" stroke="currentColor" stroke-width="var(--icon-stroke-width)" stroke-linecap="round"/>
            <path d="M7.5 5v10" stroke="currentColor" stroke-width="var(--icon-stroke-width)" stroke-linecap="round"/>
          </svg>`
        : `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M15.375 8.48516C16.5417 9.15874 16.5417 10.8427 15.375 11.5163L7.875 15.8464C6.70833 16.52 5.25 15.678 5.25 14.3308L5.25 5.67058C5.25 4.32343 6.70833 3.48146 7.875 4.15504L15.375 8.48516Z" fill="currentColor"/>
          </svg>`;
    }
  }
}

  function fmtTime(sec) {
    if (!isFinite(sec) || sec < 0) sec = 0;
    const m = Math.floor(sec / 60);
    const s = Math.floor(sec % 60);
    return `${m}:${String(s).padStart(2, "0")}`;
  }

  function setHUD(modal, meta, hasHandle) {
  const prodline = modal.querySelector(".km-video-modal__prodline");
  const img = modal.querySelector(SEL.hudImg);
  const t = modal.querySelector(SEL.hudTitle);
  const p = modal.querySelector(SEL.hudPrice);

  if (!hasHandle) {
    if (prodline) prodline.style.display = "none";
    setBuyVisible(modal, false);
    return;
  }

  if (prodline) prodline.style.display = "";

  if (img) {
    if (meta.image) {
      img.src = meta.image;
      img.style.display = "";
    } else {
      img.removeAttribute("src");
      img.style.display = "none";
    }
  }

  if (t) t.textContent = meta.title || "";
  if (p) p.textContent = meta.price || "";

  setBuyVisible(modal, true);
}

  function setProgress(modal, video) {
    const fill = modal.querySelector(SEL.progFill);
    const text = modal.querySelector(SEL.progText);
    if (!video) return;

    const dur = video.duration || 0;
    const cur = video.currentTime || 0;
    const pct = dur > 0 ? (cur / dur) * 100 : 0;

    if (fill) fill.style.width = `${clamp(pct, 0, 100)}%`;
    if (text) text.textContent = dur > 0 ? `${fmtTime(cur)} / ${fmtTime(dur)}` : "";
  }

  function setVideoSrc(video, src, muted = false) {
    if (!video) return;

    video.controls = false;
    video.removeAttribute("controls");
    video.setAttribute("playsinline", "");
    video.playsInline = true;

    safePause(video);
    video.removeAttribute("src");
    video.muted = !!muted;
    video.loop = true;

    video.src = src;
    try {
      video.load();
    } catch (e) {}
    safePlay(video);
  }

  /* ============================
     QUICK BUY via /products/{handle}.js
  ============================ */
  async function fetchProductJSON(handle) {
    const base =
      window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root
        : "/";
    const rootPath = base.endsWith("/") ? base : `${base}/`;

    const url = `${rootPath}products/${encodeURIComponent(handle)}.js?km_t=${Date.now()}`;
    const res = await fetch(url, { credentials: "same-origin" });
    if (!res.ok) throw new Error(`Produto não encontrado (${res.status})`);
    return await res.json();
  }


  function moneyBRL(cents) {
    const v = Number(cents || 0) / 100;
    return v.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
  }

  function normalizeImgUrl(imgVal) {
    if (!imgVal) return "";
    if (typeof imgVal === "string") {
      return imgVal.startsWith("//") ? `https:${imgVal}` : imgVal;
    }
    const maybe = imgVal.src || imgVal.url || imgVal.originalSrc || imgVal.featured_image || "";
    if (typeof maybe === "string" && maybe) {
      return maybe.startsWith("//") ? `https:${maybe}` : maybe;
    }
    return "";
  }

  function getOptionEl(select) {
    if (!select) return null;
    return select.options && select.selectedIndex >= 0 ? select.options[select.selectedIndex] : null;
  }

  function ensureQBImage(qbRoot) {
    if (!qbRoot) return null;
    const header = qbRoot.querySelector(".km-qb__header");
    if (!header) return null;

    let media = qbRoot.querySelector(".km-qb__media");
    let imgEl = qbRoot.querySelector(".km-qb__media img");

    if (!media) {
      media = document.createElement("div");
      media.className = "km-qb__media";
      header.prepend(media);
    }
    if (!imgEl) {
      imgEl = document.createElement("img");
      imgEl.setAttribute("loading", "lazy");
      imgEl.setAttribute("width", "160");
      imgEl.setAttribute("height", "160");
      imgEl.alt = "";
      media.appendChild(imgEl);
    }
    return imgEl;
  }

  function applyVariantUI(qbRoot) {
    if (!qbRoot) return;

    const select = qbRoot.querySelector("select[name='id']");
    const qty = qbRoot.querySelector("input[name='quantity']");
    const opt = getOptionEl(select);
    if (!qty) return;

    const min = opt ? parseInt(opt.getAttribute("data-min") || "1", 10) : 1;
    const step = opt ? parseInt(opt.getAttribute("data-step") || "1", 10) : 1;
    const maxAttr = opt ? opt.getAttribute("data-max") : null;
    const max = maxAttr ? parseInt(maxAttr, 10) : null;

    qty.min = String(min);
    qty.step = String(step);
    if (max) qty.max = String(max);
    else qty.removeAttribute("max");

    let v = parseInt(qty.value || String(min), 10);
    if (!Number.isFinite(v)) v = min;
    v = Math.max(min, v);
    if (max) v = Math.min(max, v);

    if ((v - min) % step !== 0) {
      v = min + Math.floor((v - min) / step) * step;
      v = Math.max(min, v);
      if (max) v = Math.min(max, v);
    }
    qty.value = String(v);

    const priceEl = qbRoot.querySelector(".km-qb__price-now");
    const compareEl = qbRoot.querySelector(".km-qb__price-compare");
    const badgeEl = qbRoot.querySelector(".km-qb__badge");

    if (opt) {
      const price = opt.getAttribute("data-price") || "";
      const compare = opt.getAttribute("data-compare") || "";
      const img = opt.getAttribute("data-img") || "";

      if (priceEl) priceEl.textContent = price;

      if (compareEl) {
        compareEl.textContent = compare || "";
        compareEl.style.display = compare ? "" : "none";
      }

      if (badgeEl) {
        const priceC = parseInt(opt.getAttribute("data-price-cents") || "0", 10);
        const compareC = parseInt(opt.getAttribute("data-compare-cents") || "0", 10);
        const pct = compareC > priceC && compareC > 0 ? Math.round(((compareC - priceC) / compareC) * 100) : 0;
        badgeEl.textContent = pct ? `-${pct}%` : "";
        badgeEl.style.display = pct ? "" : "none";
      }

      if (img) {
        const imgEl = ensureQBImage(qbRoot);
        if (imgEl) imgEl.src = img;
      }
    }
  }

  /* ============================
   QUICK BUY via Liquid section (metafields ok)
============================ */
async function fetchQuickBuySectionHTML(handle){
  const base =
    window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : "/";
  const rootPath = base.endsWith("/") ? base : `${base}/`;

  const url = `${rootPath}products/${encodeURIComponent(handle)}?section_id=km-quick-buy&km_t=${Date.now()}`;
  const res = await fetch(url, { credentials: "same-origin" });
  if (!res.ok) throw new Error(`Quick Buy section não carregou (${res.status})`);
  return await res.text();
}

function bindSwatches(side){
  if (!side || side.__kmSwatchesBound) return;
  side.__kmSwatchesBound = true;

  side.addEventListener("click", async (e) => {
    const btn = e.target.closest("[data-km-swatch]");
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    const handle = (btn.getAttribute("data-handle") || "").trim();
    if (!handle) return;

    await loadQuickBuyIntoSide(handle);
  });
}

  function bindQuickBuyVariantChange(side) {
    if (!side) return;
    if (side.__kmQBVariantBound) return;
    side.__kmQBVariantBound = true;

    side.addEventListener("change", (e) => {
      const sel = e.target && e.target.matches && e.target.matches("select[name='id']") ? e.target : null;
      if (!sel) return;
      const qbRoot = sel.closest("[data-km-qb]");
      applyVariantUI(qbRoot);
    });
  }

  function renderQuickBuyHTML(p) {
    const variants = Array.isArray(p.variants) ? p.variants : [];
    const firstAvail = variants.find((v) => v.available) || variants[0];

    const title = p.title || "";

    const firstImg = normalizeImgUrl((firstAvail && firstAvail.featured_image) || p.featured_image);

    const price = firstAvail ? moneyBRL(firstAvail.price) : "";
    const compare =
      firstAvail && firstAvail.compare_at_price > firstAvail.price
        ? moneyBRL(firstAvail.compare_at_price)
        : "";

    const pct =
      firstAvail && firstAvail.compare_at_price > firstAvail.price
        ? Math.round(((firstAvail.compare_at_price - firstAvail.price) / firstAvail.compare_at_price) * 100)
        : 0;

    const hasMany = variants.length > 1;

    const min0 = firstAvail?.quantity_rule?.min || 1;
    const step0 = firstAvail?.quantity_rule?.increment || 1;
    const max0 = firstAvail?.quantity_rule?.max || null;

    return `
      <div class="km-qb km-qb--v4" data-km-qb>
        <div class="km-qb__header">
          ${
            firstImg
              ? `
            <div class="km-qb__media">
              <img src="${firstImg}" alt="${title.replace(/"/g, "&quot;")}" loading="lazy" width="160" height="160">
            </div>`
              : ``
          }
          <div class="km-qb__head">
            <div class="km-qb__title">${title}</div>
            <div class="km-qb__price">
              <span class="km-qb__price-now">${price}</span>
              ${
                compare
                  ? `<span class="km-qb__price-compare">${compare}</span><span class="km-qb__badge">-${pct}%</span>`
                  : ``
              }
            </div>
          </div>
        </div>

        <form class="km-qb__form" method="post" action="/cart/add" accept-charset="UTF-8">
          <input type="hidden" name="form_type" value="product">
          <input type="hidden" name="utf8" value="✓">

          <div class="km-qb__blocks">

            ${
              hasMany
                ? `
              <div>
                <label class="km-qb__label" for="km-qb-variant-js">Variante</label>
                <select id="km-qb-variant-js" name="id" class="km-qb__select">
                  ${variants
                    .map((v) => {
                      const img = normalizeImgUrl(v.featured_image || p.featured_image);
                      const min = v.quantity_rule?.min || 1;
                      const step = v.quantity_rule?.increment || 1;
                      const max = v.quantity_rule?.max || null;
                      const compareOk = v.compare_at_price && v.compare_at_price > v.price;

                      return `
                        <option
                          value="${v.id}"
                          ${firstAvail && v.id === firstAvail.id ? "selected" : ""}
                          ${v.available ? "" : "disabled"}

                          data-available="${v.available ? "true" : "false"}"
                          data-price="${moneyBRL(v.price)}"
                          data-price-cents="${v.price}"
                          data-compare="${compareOk ? moneyBRL(v.compare_at_price) : ""}"
                          data-compare-cents="${v.compare_at_price || 0}"
                          data-img="${img}"

                          data-min="${min}"
                          data-step="${step}"
                          ${max ? `data-max="${max}"` : ``}
                        >
                          ${v.title}${v.available ? "" : " — Esgotado"}
                        </option>
                      `;
                    })
                    .join("")}
                </select>
              </div>
            `
                : `
              <input type="hidden" name="id" value="${firstAvail ? firstAvail.id : ""}">
            `
            }

            <div>
              <div class="km-qb__row">
  <div class="km-qb__qty">
    <button class="km-qb__qty-btn" type="button" data-km-qb-qty-minus aria-label="Diminuir">
  <span class="km-icon km-icon--minus" aria-hidden="true">
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2.75 7H11.25" stroke="currentColor" stroke-width="var(--icon-stroke-width)" stroke-linecap="round"/>
    </svg>
  </span>
</button>

    <input
      id="km-qb-qty-js"
      class="km-qb__qty-input"
      type="number"
      name="quantity"
      value="${min0}"
      min="${min0}"
      step="${step0}"
      ${max0 ? `max="${max0}"` : ``}
      inputmode="numeric"
      data-km-qb-qty
    >

    <button class="km-qb__qty-btn" type="button" data-km-qb-qty-plus aria-label="Aumentar">
  <span class="km-icon km-icon--plus" aria-hidden="true">
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path class="vertical" d="M2.75 7H11.25" stroke="currentColor" stroke-width="var(--icon-stroke-width)" stroke-linecap="round"/>
      <path class="horizontal" d="M7 2.75L7 11.25" stroke="currentColor" stroke-width="var(--icon-stroke-width)" stroke-linecap="round"/>
    </svg>
  </span>
</button>
  </div>

  <button type="submit" class="button button-primary km-qb__btn km-qb__btn--row" data-km-qb-buy>
    ADICIONAR
  </button>
</div>

<div class="km-qb__sub">Frete e prazo calculados no checkout.</div>
<div class="km-qb__note" data-km-qb-note aria-live="polite"></div>
</div>

          </div>
        </form>
      </div>
    `;
  }

  async function loadQuickBuyIntoSide(handle) {
    const modal = ensureModal();
    const side = modal.querySelector(SEL.side);
    if (!side) return;

    side.innerHTML = `
      <button class="km-video-modal__side-close" type="button" data-km-side-close aria-label="Fechar compra">×</button>
      <div style="padding:10px; font-size:13px; opacity:.75;">Carregando…</div>
    `;
    openSide(modal, true);

    try {
  const html = await fetchQuickBuySectionHTML(handle);

  side.innerHTML = `
    <button class="km-video-modal__side-close" type="button" data-km-side-close aria-label="Fechar compra">
  <span class="km-icon km-icon--close" aria-hidden="true">
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 2L2 12" stroke="currentColor" stroke-width="var(--icon-stroke-width)" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M12 12L2 2" stroke="currentColor" stroke-width="var(--icon-stroke-width)" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </span>
</button>
    ${html}
  `;

  // Swatches (se existirem no Liquid)
  bindSwatches(side);

  // init do km-quick-buy.js (AJAX cart + stepper + sync)
  if (window.KMQuickBuy && typeof window.KMQuickBuy.init === "function") {
    window.KMQuickBuy.init(side);
  } else {
    document.dispatchEvent(new CustomEvent("km:quickbuy:mount", { detail: { root: side } }));
  }
} catch (err) {
      side.innerHTML = `
        <button class="km-video-modal__side-close" type="button" data-km-side-close aria-label="Fechar compra">×</button>
        <div style="padding:10px; font-size:13px;">Erro ao carregar Quick Buy.</div>
        <div style="padding:10px; font-size:12px; opacity:.7;">${String(err?.message || err)}</div>
        <div style="padding:10px; font-size:12px; opacity:.7; border-top:1px solid rgba(0,0,0,.08);">
          <div><b>Produto:</b> ${handle}</div>
        </div>
      `;
      openSide(modal, true);
    }
  }

  /* ============================
     OPEN / CLOSE / NAV
  ============================ */
  function openModal(root, card) {
    const modal = ensureModal();
    const video = modal.querySelector(SEL.modalVideo);

    ACTIVE_ROOT = root;
    applyRootBlurFromSection(root);

    const cards = getCards(root);
    const index = getCardIndex(root, card);
    const src = getMp4FromCard(card);
    const handle = getHandleFromCard(card);
    const meta = getMetaFromCard(card);

    setModalState(modal, { index, handle });

    setVideoSrc(video, src, false);
    setHUD(modal, meta, !!handle);
    openSide(modal, false);

    const btnPrev = modal.querySelector(SEL.btnPrev);
    const btnNext = modal.querySelector(SEL.btnNext);
    if (btnPrev) btnPrev.disabled = cards.length <= 1;
    if (btnNext) btnNext.disabled = cards.length <= 1;

    modal.hidden = false;
    modal.style.display = "block";
    modal.setAttribute("aria-hidden", "false");
    document.documentElement.style.overflow = "hidden";

    updateButtons(modal, video);
    setProgress(modal, video);
  }

  function closeModal() {
    const modal = document.querySelector(SEL.modal);
    if (!modal) return;

    // ✅ se estava em modo single, garante que arrows voltem pro estado normal
if (modal.__kmSingleMode) {
  modal.__kmSingleMode = false;
  const btnPrev = modal.querySelector(SEL.btnPrev);
  const btnNext = modal.querySelector(SEL.btnNext);
  if (btnPrev) btnPrev.style.display = "";
  if (btnNext) btnNext.style.display = "";
}

    const video = modal.querySelector(SEL.modalVideo);
    safePause(video);
    try {
      video.removeAttribute("src");
      video.load();
    } catch (e) {}

    openSide(modal, false);

    modal.setAttribute("aria-hidden", "true");
    modal.hidden = true;
    modal.style.display = "none";
    document.documentElement.style.overflow = "";

    ACTIVE_ROOT = null;
  }

  function gotoIndex(nextIndex) {
    const modal = ensureModal();
    const video = modal.querySelector(SEL.modalVideo);

    const root = ACTIVE_ROOT;
    if (!root) return;

    const cards = getCards(root);
    if (!cards.length) return;

    const idx = (nextIndex + cards.length) % cards.length;
    const card = cards[idx];

    const src = getMp4FromCard(card);
    const handle = getHandleFromCard(card);
    const meta = getMetaFromCard(card);

    setModalState(modal, { index: idx, handle });

    setVideoSrc(video, src, false);
    setHUD(modal, meta, !!handle);

    openSide(modal, false);
    updateButtons(modal, video);
    setProgress(modal, video);
  }

  /* ============================
     EVENTS (bind once)
  ============================ */
  function bindModalEvents() {
    const modal = ensureModal();
    if (modal.__kmBound) return;
    modal.__kmBound = true;

    const backdrop = modal.querySelector(SEL.modalBackdrop);
    const btnClose = modal.querySelector(SEL.btnClose);
    const btnMute = modal.querySelector(SEL.btnMute);
    const btnPause = modal.querySelector(SEL.btnPause);
    const btnBuy = modal.querySelector(SEL.btnBuy);
    const btnPrev = modal.querySelector(SEL.btnPrev);
    const btnNext = modal.querySelector(SEL.btnNext);
    const video = modal.querySelector(SEL.modalVideo);
    const prog = modal.querySelector(SEL.prog);
    const side = modal.querySelector(SEL.side);

    const onClose = () => closeModal();

    backdrop && backdrop.addEventListener("click", onClose);
    btnClose && btnClose.addEventListener("click", onClose);

    if (side) {
      side.addEventListener("click", (e) => {
        const closeBtn = e.target.closest(SEL.btnSideClose);
        if (closeBtn) {
          e.preventDefault();
          e.stopPropagation();
          openSide(modal, false);
          return;
        }
        e.stopPropagation();
      });
    }

    video &&
      video.addEventListener("click", () => {
        if (video.paused) safePlay(video);
        else safePause(video);
        updateButtons(modal, video);
      });

    btnMute &&
      btnMute.addEventListener("click", () => {
        video.muted = !video.muted;
        updateButtons(modal, video);
      });

    btnPause &&
      btnPause.addEventListener("click", () => {
        if (video.paused) safePlay(video);
        else safePause(video);
        updateButtons(modal, video);
      });

    btnPrev &&
      btnPrev.addEventListener("click", () => {
        const st = getModalState(modal);
        gotoIndex(st.index - 1);
      });

    btnNext &&
      btnNext.addEventListener("click", () => {
        const st = getModalState(modal);
        gotoIndex(st.index + 1);
      });

    if (video) {
      video.addEventListener("timeupdate", () => setProgress(modal, video));
      video.addEventListener("loadedmetadata", () => setProgress(modal, video));
      video.addEventListener("durationchange", () => setProgress(modal, video));
    }

    if (prog && video) {
      prog.addEventListener("click", (e) => {
        const rect = prog.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const pct = rect.width > 0 ? x / rect.width : 0;
        const dur = video.duration || 0;
        if (dur > 0) video.currentTime = clamp(dur * pct, 0, dur);
      });
    }

    btnBuy &&
      btnBuy.addEventListener("click", async () => {
        const st = getModalState(modal);
        if (!st.handle) return;

        const sideEl = modal.querySelector(SEL.side);
        const isOpen = sideEl && !sideEl.hidden;

        if (isOpen) {
          openSide(modal, false);
          return;
        }

        await loadQuickBuyIntoSide(st.handle);
      });

    document.addEventListener("keydown", (e) => {
      if (modal.getAttribute("aria-hidden") !== "false") return;

      if (e.key === "Escape") onClose();

      if (e.key === "ArrowLeft") {
        const st = getModalState(modal);
        gotoIndex(st.index - 1);
      }
      if (e.key === "ArrowRight") {
        const st = getModalState(modal);
        gotoIndex(st.index + 1);
      }
    });
  }

  function bindCards(root) {
    if (root.__kmCardsBound) return;
    root.__kmCardsBound = true;

    root.addEventListener("click", (e) => {
  const card = e.target.closest(SEL.card);
  if (!card) return;

  // ✅ se tiver link em volta, não navega
  const link = e.target.closest("a[href]");
  if (link) {
    e.preventDefault();
    e.stopPropagation();
  }

  openModal(root, card);
});

   root.addEventListener("keydown", (e) => {
  const card = e.target.closest(SEL.card);
  if (!card) return;
  if (e.key !== "Enter" && e.key !== " ") return;

  const link = e.target.closest("a[href]");
  if (link) {
    e.preventDefault();
    e.stopPropagation();
  } else {
    e.preventDefault();
  }

  openModal(root, card);
});
  }

  function init(root) {
    if (!root || root.__kmVideoInit) return;
    root.__kmVideoInit = true;

    setupAutoplay(root);
    bindModalEvents(); // bind once global
    bindCards(root);
  }

    function boot(scope = document) {
    hardHideAllModals();
    scope.querySelectorAll(SEL.root).forEach(init);
  }

  // ✅ roda mesmo se o script carregar depois do DOMContentLoaded
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => boot(document));
  } else {
    boot(document);
  }

  // ✅ Theme editor
  document.addEventListener("shopify:section:load", (e) => {
    boot(e.target);
  });

  // ✅ boot manual (se algum trecho for injetado por AJAX)
  document.addEventListener("km:video:boot", (e) => {
    boot(e.detail?.scope || document);
  });

/* ============================
   PUBLIC API — Floating Video
   - abre o modal com 1 vídeo (sem arrows / sem quick buy)
============================ */
window.KMVideoEngine = window.KMVideoEngine || {};

window.KMVideoEngine.openSingle = function openSingle(opts){
  // garante que modal existe e está bindado
  bindModalEvents();

  const modal = ensureModal();
  const video = modal.querySelector(SEL.modalVideo);

  const src = (opts && opts.src) ? String(opts.src) : "";
  if (!src) return;

  // marca modo single (pra closeModal restaurar arrows)
  modal.__kmSingleMode = true;

  // desliga root ativo (sem navegação)
  ACTIVE_ROOT = null;
  setModalState(modal, { index: 0, handle: "" });

  // video
  setVideoSrc(video, src, !!(opts && opts.muted));

  // HUD e compra off
  setHUD(modal, { title:"", price:"", image:"" }, false);
  openSide(modal, false);

  // esconde arrows
  const btnPrev = modal.querySelector(SEL.btnPrev);
  const btnNext = modal.querySelector(SEL.btnNext);
  if (btnPrev) btnPrev.style.display = "none";
  if (btnNext) btnNext.style.display = "none";

  // abre
  modal.hidden = false;
  modal.style.display = "block";
  modal.setAttribute("aria-hidden", "false");
  document.documentElement.style.overflow = "hidden";

  updateButtons(modal, video);
  setProgress(modal, video);
};

// close público (pro floating fechar se quiser)
window.KMVideoEngine.close = function(){
  closeModal();
};

// ✅ sinaliza que o engine está pronto (floating pode abrir sem polling)
window.KMVideoEngine = window.KMVideoEngine || {};
window.KMVideoEngine.__ready = true;
document.dispatchEvent(new CustomEvent("km:video:ready"));

})();